import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../../i18n/runtime";
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import {RequirementDetails} from '../../components/VisaRequirements';
import CurrencySelect from '../../components/CurrencySelect';
import { useAuth } from '../../context/AuthContext';
const types = {
  visa: "تأشيرة",
  flight: "تذكرة طيران",
  hotel: "حجز فندق",
  bus: "تذكرة حافلة"
};
const statuses = {
  pending: "قيد الانتظار",
  confirmed: "قيد التنفيذ",
  completed: "مكتملة",
  cancelled: "ملغاة"
};
const inputClass = 'block w-full border rounded-lg p-2 mt-1';
const buttonClass = 'bg-[#6B5B95] text-white rounded-lg px-4 py-2 disabled:opacity-50';
const newId = () => Array.from(crypto.getRandomValues(new Uint8Array(16)), n => n.toString(16).padStart(2, '0')).join('');
export default function OperationsPage({
  customerView = false
}) {
  __useLocale();
  const {
    token
  } = useAuth();
  const [data, setData] = useState({
    operations: [],
    customers: []
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [reload, setReload] = useState(0);
  const [form, setForm] = useState(null);
  const [file, setFile] = useState(null);
  const [query, setQuery] = useState('');
  const [type, setType] = useState('');
  const [status, setStatus] = useState('');
  const running = useRef(false);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError('');
    axios.get('/api/operations.php', {
      headers: {
        Authorization: `Bearer ${token}`
      },
      signal: controller.signal
    }).then(r => setData(r.data)).catch(e => {
      if (!controller.signal.aborted) setError(e.response?.data?.message || "تعذر تحميل العمليات");
    }).finally(() => {
      if (!controller.signal.aborted) setLoading(false);
    });
    return () => controller.abort();
  }, [token, reload]);
  const download = async d => {
    try {
      const r = await axios.get('/api/operations.php', {
        params: {
          [d.requirement?'requirement_file':'document']: d.id
        },
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = d.file_name;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch (e) {
      setError(__tr("تعذر تنزيل المرفق. تحقق من الاتصال وأعد المحاولة."));
    }
  };
  const save = async e => {
    e.preventDefault();
    if (running.current) return;
    if (file && file.size > 2 * 1024 * 1024) {
      setError(__tr("حجم الملف يجب ألا يتجاوز 2 ميجابايت"));
      return;
    }
    running.current = true;
    setBusy(true);
    setError('');
    const payload = new FormData();
    ['id', 'user_id', 'booking_type', 'currency', 'total_amount', 'from_location', 'to_location', 'notes', 'status'].forEach(k => payload.append(k, form[k] ?? ''));
    if (file) payload.append('document', file);
    try {
      await axios.post(`/api/operations.php?action=${form.isNew ? 'create' : 'update'}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setForm(null);
      setFile(null);
      setReload(n => n + 1);
    } catch (e) {
      setError(e.response?.data?.message || "تعذر الحفظ، يمكنك إعادة المحاولة");
    } finally {
      running.current = false;
      setBusy(false);
    }
  };
  const rows = data.operations.filter(r => (!type || r.booking_type === type) && (!status || r.status === status) && [r.id, r.customer_name, r.to_location, r.notes].some(v => String(v || '').toLowerCase().includes(query.toLowerCase())));
  const field = (name, label, inputType = 'text') => <label>{__tr(label)}<input required={['total_amount'].includes(name)} type={inputType} min="0" step="0.01" className={inputClass} value={form[name] || ''} onChange={e => setForm({
      ...form,
      [name]: e.target.value
    })} /></label>;
  return <section className="bg-white rounded-xl p-5 space-y-4" dir={__direction()}>
    <div className="flex flex-wrap justify-between gap-3"><h2 className="text-xl font-bold">{__tr(customerView ? "طلباتي ومستنداتي" : "العمليات")}</h2><div className="flex gap-3"><button onClick={() => setReload(n => n + 1)} disabled={busy}>{__tr("تحديث")}</button>{__tr(!customerView && <button className={buttonClass} onClick={() => {
          setFile(null);
          setForm({
            id: newId(),
            isNew: true,
            user_id: '',
            booking_type: 'visa',
            currency: '',
            total_amount: '0',
            status: 'pending',
            notes: ''
          });
        }}>{__tr("إضافة عملية")}</button>)}</div></div>
    {__tr(error && <p role="alert" className="text-red-700">{__tr(error)}</p>)}
    {__tr(form && <form onSubmit={save} className="border rounded-xl p-4 space-y-4"><fieldset disabled={busy} className="space-y-4"><h3 className="font-bold">{__tr(form.isNew ? "عملية جديدة" : `${types[form.booking_type]} — ${form.customer_name}`)}</h3><div className="grid md:grid-cols-3 gap-4">
      {__tr(form.isNew && <><label>{__tr("العميل")}<select required className={inputClass} value={form.user_id} onChange={e => setForm({
                ...form,
                user_id: e.target.value
              })}><option value="">{__tr("اختر العميل")}</option>{__tr(data.customers.map(c => <option key={c.id} value={c.id}>{__tr(c.full_name)}</option>))}</select></label><label>{__tr("نوع الخدمة")}<select className={inputClass} value={form.booking_type} onChange={e => setForm({
                ...form,
                booking_type: e.target.value
              })}>{__tr(Object.entries(types).map(([v, l]) => <option key={v} value={v}>{__tr(l)}</option>))}</select></label><label>{__tr("العملة")}<CurrencySelect required value={form.currency} onChange={e => setForm({
                ...form,
                currency: e.target.value
              })} /></label>{__tr(field('total_amount', "قيمة الخدمة", 'number'))}{__tr(field('from_location', "من"))}{__tr(field('to_location', "الوجهة / الدولة"))}</>)}
      <label>{__tr("الحالة")}<select className={inputClass} value={form.status} onChange={e => setForm({
              ...form,
              status: e.target.value
            })}>{__tr(Object.entries(statuses).map(([v, l]) => <option key={v} value={v}>{__tr(l)}</option>))}</select></label>
      <label>{__tr("ملاحظات")}<textarea maxLength={2000} className={inputClass} value={form.notes || ''} onChange={e => setForm({
              ...form,
              notes: e.target.value
            })} /></label>
      <label>{__tr("إرفاق ")}{__tr(types[form.booking_type])}{__tr(" (صورة أو PDF)")}<input key={form.id} type="file" accept=".pdf,.jpg,.jpeg,.png,.webp" className={inputClass} onChange={e => setFile(e.target.files[0] || null)} /><span className="text-sm text-gray-500">{__tr("حتى 2 ميجابايت لكل ملف. يظهر للعميل في حسابه.")}</span></label>
    </div><p className="text-sm text-gray-600">{__tr("إكمال العملية يتطلب مستند إنجاز. تغيير حالتها لا يُنشئ فاتورة أو يُلغي قيودًا مالية.")}</p><RequirementDetails operation={form} download={download} />{__tr(form.documents?.map(d => <button type="button" key={d.id} className="text-purple-700 block" onClick={() => download(d)}>{__tr(d.file_name)}</button>))}<button className={buttonClass}>{__tr(busy ? "جارٍ الحفظ…" : "حفظ العملية")}</button> <button type="button" onClick={() => setForm(null)}>{__tr("إغلاق")}</button></fieldset></form>)}
    <div className="flex flex-wrap gap-3"><input aria-label={__tr("بحث العمليات")} placeholder={__tr("بحث بالعميل أو الوجهة أو الرقم")} className="border rounded p-2 flex-1" value={query} onChange={e => setQuery(e.target.value)} /><select aria-label={__tr("نوع الخدمة")} className="border rounded p-2" value={type} onChange={e => setType(e.target.value)}><option value="">{__tr("كل الخدمات")}</option>{__tr(Object.entries(types).map(([v, l]) => <option key={v} value={v}>{__tr(l)}</option>))}</select><select aria-label={__tr("حالة العملية")} className="border rounded p-2" value={status} onChange={e => setStatus(e.target.value)}><option value="">{__tr("كل الحالات")}</option>{__tr(Object.entries(statuses).map(([v, l]) => <option key={v} value={v}>{__tr(l)}</option>))}</select></div>
    {__tr(loading ? <p role="status">{__tr("جارٍ التحميل…")}</p> : <div className="overflow-x-auto"><table className="w-full text-sm"><thead><tr>{__tr(["الرقم", "العميل", "الخدمة", "الوجهة", "القيمة", "الحالة", "المستندات", ...(!customerView ? ["الإجراء"] : [])].map(h => <th key={h} className="p-3 text-right border-b">{__tr(h)}</th>))}</tr></thead><tbody>{__tr(rows.map(r => <tr key={r.id}><td className="p-3 border-b" title={__tr(r.id)}>{__tr(r.id.slice(0, 8))}</td><td className="p-3 border-b">{__tr(r.customer_name)}</td><td className="p-3 border-b">{__tr(types[r.booking_type])}</td><td className="p-3 border-b">{__tr(r.to_location)}</td><td className="p-3 border-b">{__tr(r.total_amount)} {__tr(r.currency)}</td><td className="p-3 border-b">{__tr(statuses[r.status])}{__tr(r.checkout && <div className="text-xs mt-1">{__tr({
                  paid: "مسدد إلكترونيًا",
                  test_paid: "دفع تجريبي",
                  cancelled: "شراء ملغى",
                  pending: "بانتظار السداد"
                }[r.checkout.status])}{__tr(customerView && <a className="block text-purple-700 underline" href={`/checkout?order=${r.checkout.id}`}>{__tr("تفاصيل الشراء والدفع")}</a>)}</div>)}</td><td className="p-3 border-b"><RequirementDetails operation={r} download={download} />{__tr(r.documents.map(d => <button key={d.id} onClick={() => download(d)} className="block text-purple-700 underline">{__tr(d.file_name)}</button>))}</td>{__tr(!customerView && <td className="p-3 border-b"><button disabled={r.status === 'cancelled'} className="text-purple-700 disabled:text-gray-400" onClick={() => {
                setFile(null);
                setForm({
                  ...r,
                  isNew: false
                });
              }}>{__tr("متابعة / إرفاق")}</button></td>)}</tr>))}</tbody></table>{__tr(!rows.length && !error && <p className="p-4">{__tr("لا توجد عمليات.")}</p>)}</div>)}
  </section>;
}
